// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__9yGUa","inputWrap":"Table_inputWrap__wXBGY","col":"Table_col__3RxGM","bmiTooltip":"Table_bmiTooltip__1kfNL"};